<template >
  <div>
    <div class="row">
      <div class="col-12">
        <div class="row mt-5">
          <div class="form-group">
            <div class="form-label-group pl-5 pt-1">
              <div class="dropdown ml-3">
                <button
                  class="btn green-color dropdown-toggle"
                  type="button"
                  id="dropdownMenuButtonSearch"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  {{ dropDownStatusName }}
                </button>
                <div
                  class="dropdown-menu"
                  aria-labelledby="dropdownMenuButtonSearch"
                  style="max-height: 400px; overflow: hidden auto"
                >
                  <a
                    class="dropdown-item pointer"
                    v-for="item in statusesArray"
                    :key="item.id"
                    @click="dropDownStatusClick(item.name, item.id)"
                    >{{ item.name }}</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="no-more-tables">
      <table
        class="col-md-12 table-bordered table-striped table-condensed cf mt-5"
      >
        <thead class="cf" style="border-style: none">
          <tr>
            <th class="numeric">შესყიდვის თარიღი</th>
            <th class="numeric">შესყიდული პროდუქტების რაოდენობა</th>
            <th class="numeric">საკონტაქტო ტელეფონი</th>
          </tr>
        </thead>
        <tbody>
          <tr class="heading" v-for="value in array" :key="value.id">
            <td data-title="შესყიდვის თარიღი" class="numeric">
              {{ value.date }}
            </td>
            <td data-title="შესყიდული პროდუქტების რაოდენობა" class="numeric">
              {{ value.productsCount }}
            </td>
            <td data-title="საკონტაქტო ტელეფონი" class="numeric">
              {{ value.mobile }}
            </td>
            <td data-title="დეტალები" class="numeric">
              <div>
                <i
                  class="fa fa-pencil-alt fa-fw editBtn"
                  title="დეტალები"
                  data-toggle="modal"
                  data-target="#exampleModalLongEdit"
                  data-backdrop="static"
                  data-keyboard="false"
                  @click="viewApplication(value)"
                ></i>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div
      class="modal fade bd-example-modal-lg"
      id="exampleModalLongEdit"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLongEdit1"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header pastel-green-color">
            <h5 class="modal-title text-white" id="exampleModalLongEdit1">
            </h5>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
             <div class="modal-body">
            <div class="row">
              <form class="col-12 col-md-6">
                <div class="form-group">
                  <div class="form-label-group">
                    <input
                      type="text"
                      id="inputName"
                      class="form-control"
                      autofocus="autofocus"
                      v-model="application.date"
                      readonly
                    />
                    <label for="inputName">შესყიდვის თარიღი</label>
                  </div>
                  <div class="form-label-group mt-3">
                    <input
                      type="text"
                      id="parameter1"
                      class="form-control"
                      v-model="application.productsCount"
                      readonly
                    />
                    <label for="parameter1">შესყიდული პროდუქტების რაოდენობა</label>
                  </div>
                </div>
              </form>
              <form class="col-12 col-md-6">
                <div class="form-group">
                  <div class="form-label-group">
                    <input
                      type="text"
                      id="parameter2"
                      class="form-control"
                      v-model="application.mobile"
                      readonly
                    />
                    <label for="parameter2">კლიენტის საკონტაქტო ტელეფონი</label>
                  </div>
                </div>
                <div class="form-label-group mt-3">
                  <input
                    type="text"
                    id="parameter3"
                    class="form-control"
                    v-model="application.clientName"
                    readonly
                  />
                  <label for="parameter3">კლიენტის სახელი და გვარი</label>
                </div>
                <div class="form-label-group mt-3">
                  <input
                    type="text"
                    id="parameter4"
                    class="form-control"
                    v-model="application.address"
                    readonly
                  />
                  <label for="parameter4">კლიენტის მიერ მითითებული მიწოდების მისამართი</label>
                </div>
              </form>
              <form class="col-12 col-md-12">
                <textarea
                  id="inputInfo"
                  class="form-control"
                  style="height: 100px; margin-top: 15px"
                  placeholder="კლიენტის კომენტარი"
                  autofocus="autofocus"
                  v-model="application.clientComment"
                  readonly
                />
              </form>
              <form class="col-12 col-md-12">
                <textarea
                  id="inputInfo"
                  class="form-control"
                  style="height: 100px; margin-top: 15px"
                  placeholder="ოპერატორის კომენტარი"
                  autofocus="autofocus"
                  v-model="application.operatorComment"
                />
              </form>
               <div id="no-more-tables">
              <table
                class="col-md-12 table-bordered table-striped table-condensed cf mt-5"
              >
                <thead class="cf" style="border-style: none">
                  <tr>
                    <th class="numeric">დასახელება</th>
                    <th class="numeric">რაოდენობა</th>
                    <th class="numeric">მერჩანტი</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    class="heading"
                    v-for="value in application.products"
                    :key="value.id"
                  >
                    <td data-title="დასახელება" class="numeric">
                      {{ value.name }}
                    </td>
                    <td data-title="რაოდენობა" class="numeric">
                      {{ value.count }}
                    </td>
                    <td data-title="მერჩანტი" class="numeric">
                      {{ value.legal }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="modal-footer">
            <button
             v-if="this.application.statusId != 3"
              type="button"
              class="btn btn-success"
              @click="editApplication()"
              data-dismiss="modal"
            >
             რედაქტირება
            </button>
             <button
               v-if="this.application.statusId != 3"
              type="button"
              class="btn btn-success"
              @click="processApplication()"
              data-dismiss="modal"
            >
               დამუშავება
            </button>
          </div>
            <button type="button" class="btn btn-danger" data-dismiss="modal">
              დახურვა
            </button>
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "../../assets/js/sb-admin.min.js";
import "../../assets/vendor/datatables/jquery.dataTables.js";
import "../../assets/vendor/datatables/dataTables.bootstrap4.js";
import "../../assets/js/demo/datatables-demo.js";
import { bus } from "../common/bus";

export default {
  name: "Applications",
  data() {
    return {
      array: "",
      statusesArray: [],
      dropDownStatusName: "შემოსული განაცხადები",
      application: {
        id: "",
        date: "",
        statusId: "",
        productsCount: "",
        mobile: "",
        clientName: "",
        address: "",
        clientComment: "",
        operatorComment: "",
        products: [],
      },
      currentStatusId: 1,
    };
  },

  async created() {
    this.statusesArray.push({ id: 1, name: "შემოსული განაცხადები" });
    this.statusesArray.push({
      id: 2,
      name: "დამუშვების პროცესში მყოფი განაცხადები",
    });
    this.statusesArray.push({ id: 3, name: "დასრულებული განაცხადები" });

    this.dropDownStatusName = "შემოსული განაცხადები";
    this.currentStatusId = 1;
    let result = await this.$http.getProcurementApplications({
      statusId: 1,
    });
    this.array = result.data;
  },
  methods: {
    async deleteAccount(value) {
      //ახლის დამატება
      try {
        let result = await this.$http.deleteAppAccounts({ id: value });

        if (result.data.resultCode === "200") {
          bus.$emit("success", "მომხმარებელი წარმატებით წაიშალა");

          let result = await this.$http.getAppAccounts({
            isAnonymous: this.isAnonymous,
          });
          this.array = result.data.res;
        } else {
          bus.$emit("warning", "მომხმარებლის წაშლის დროს მოხდა შეცდომა");
        }
      } catch (error) {
        bus.$emit("error", error);
      }
    },
    async deleteAccountOperations(value) {
      //ახლის დამატება
      try {
        let result = await this.$http.deleteUserOperations({ userId: value });

        if (result.data.status === "200") {
          bus.$emit("success", "ოპერაციები წარმატებით წაიშალა");

          let result = await this.$http.getAppAccounts({
            isAnonymous: this.isAnonymous,
          });
          this.array = result.data.res;
        } else {
          bus.$emit("warning", "ოპერაციების წაშლის დროს მოხდა შეცდომა");
        }
      } catch (error) {
        bus.$emit("error", error);
      }
    },
    async addPoints(partnerId, points, partnerCustomerId, userId) {
      //ახლის დამატება
      try {
        let result = await this.$http.addPoints({
          partnerId: partnerId,
          points: points,
          partnerCustomerId: partnerCustomerId,
        });
        if (result.data.status == "200") {
          bus.$emit("success", "წარმატებით დაემატა");

          this.editPoints(userId);
          this.pointsToAdd1 = null;
          //let result = await this.$http.getAppAccounts({
          //isAnonymous: this.isAnonymous,
          //});
          //this.array = result.data.res;
        } else {
          bus.$emit("warning", "დაფიქსირდა შეცდომა");
        }
      } catch (error) {
        bus.$emit("error", error);
      }
    },
    async processApplication() {
      try {
        let result = await this.$http.proccessProcurementApplication({
          id: this.application.id,
        });

        if (result.status == "200") {
          bus.$emit("success", "წარმატებით შეიცვალა");

          let result = await this.$http.getProcurementApplications({
            statusId: this.currentStatusId,
          });
          this.array = result.data;
        } else {
          bus.$emit("warning", "დაფიქსირდა შეცდომა");
        }
      } catch (error) {
        bus.$emit("error", error);
      }
    },
    async editApplication() {
      try {
        let result = await this.$http.editProcurementApplication({
          operatorComment: this.application.operatorComment,
          id: this.application.id,
        });

        if (result.status == "200") {
          bus.$emit("success", "წარმატებით შეიცვალა");

          let result = await this.$http.getProcurementApplications({
            statusId: this.currentStatusId,
          });
          this.array = result.data;
        } else {
          bus.$emit("warning", "დაფიქსირდა შეცდომა");
        }
      } catch (error) {
        bus.$emit("error", error);
      }
    },

    async viewApplication(row) {
      this.application = Object.assign({}, row);
    },
    clearData() {
      this.application.id = null;
      this.application.date = "";
      this.application.statusId = "";
      this.application.productsCount = "";
      this.application.mobile = "";
      this.application.clientName = "";
      this.application.address = "";
      this.application.clientComment = "";
      this.application.operatorComment = "";
      this.application.products = [];
    },
    async dropDownStatusClick(name, id) {
      this.dropDownStatusName = name;
      this.currentStatusId = id;
      let result = await this.$http.getProcurementApplications({
        statusId: id,
      });
      this.array = result.data;
    },
  },
};
</script>
<style scoped lang="scss">
@import "../../assets/scss/_variables.scss";
@import "../../assets/scss/_mixins.scss";
@import "../../assets/scss/_navbar.scss";
@import "../../assets/scss/sb-admin.scss";
@import "../../assets/css/sb-admin.css";
@import "../../assets/vendor/datatables/dataTables.bootstrap4.css";
@import "../../assets/scss/_login.scss";
@import "../../assets/scss/_global.scss";

.error-border {
  border-color: #ffb3b3;
  box-shadow: none;
}
.editBtn {
  margin-left: 10px;
  font-size: 30px;
  cursor: pointer;
  color: #52af8e;
}
.deleteBtn {
  font-size: 30px;
  cursor: pointer;
  color: #d43f3a;
  margin-left: 10px;
}

.searchBtn {
  font-size: 40px;
  margin-top: -5px;
  cursor: pointer;
  color: #489d7f;
}

.addNewBtn {
  font-size: 44px;
  margin-left: 15px;
  cursor: pointer;
  color: #52af8e;
  margin-top: -5px;
}
</style>



// WEBPACK FOOTER //
// src/components/view/CartManagement.vue